module.exports = __webpack_public_path__ + "static/media/AgriX_LogoX.5af1d4d6.png";